import React from 'react';

import eye from './eye.png';
import eye2x from './eye@2x.png';
import tablet from './tablet.png';
import tablet2x from './tablet@2x.png';
import quicker from './quicker.png';
import quicker2x from './quicker@2x.png';
import cashregister from './cashregister.png';
import cashregister2x from './cashregister@2x.png';
import dish from './dish.png';
import dish2x from './dish@2x.png';
import MEP from './MEP.png';
import MEP2x from './MEP@2x.png';
import tasklist from './tasklist.png';
import tasklist2x from './tasklist@2x.png';
import whiteboard from './whiteboard.png';
import whiteboard2x from './whiteboard@2x.png';

function imgElement(icon: string, icon2x: string): JSX.Element {
  return <img src={icon} srcSet={`${icon2x} 2x`} alt="" />;
}

export const eyeIcon = imgElement(eye, eye2x);
export const tabletIcon = imgElement(tablet, tablet2x);
export const quickerIcon = imgElement(quicker, quicker2x);
export const cashregisterIcon = imgElement(cashregister, cashregister2x);
export const dishIcon = imgElement(dish, dish2x);
export const MEPIcon = imgElement(MEP, MEP2x);
export const tasklistIcon = imgElement(tasklist, tasklist2x);
export const whiteboardIcon = imgElement(whiteboard, whiteboard2x);



// WEBPACK FOOTER //
// ./src/static/images/icons/index.tsx